import { FileMarkdownFilled } from '@ant-design/icons';
import axios from 'axios';
import {
  AiIcon,
  DefaultFileTypeIcon,
  DocIcon,
  DocxIcon,
  EpsIcon,
  GifIcon,
  IdIcon,
  JpegIcon,
  JpgIcon,
  PdfIcon,
  PngIcon,
  PptIcon,
  PptxIcon,
  PsdIcon,
  RarIcon,
  SvgIcon,
  TiffIcon,
  TifIcon,
  XlsIcon,
  XlsxIcon,
  ZipIcon,
} from 'components/Icons';
import { FileItem } from 'domains/workspaceDetailDomain';

export const getFilePath = (fileItem: FileItem) => {
  return (fileItem.urlPrefix || '') + fileItem.fileUrl.replace(/^\//, '');
};

export const downloadFile = async (fileItem: FileItem) => {
  const resp = await axios.get(getFilePath(fileItem), {
    responseType: 'blob',
  });
  const blob = new Blob([resp.data], { type: 'application/octet-stream' });
  const blobURL = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobURL;
  a.download = fileItem.fileName;
  a.click();
  window.URL.revokeObjectURL(blobURL);
};

export const getFileIcon = (type: string) => {
  const IconMap: { [key: string]: React.ReactNode } = {
    md: <FileMarkdownFilled />,
    ai: <AiIcon />,
    doc: <DocIcon />,
    docx: <DocxIcon />,
    eps: <EpsIcon />,
    gif: <GifIcon />,
    indd: <IdIcon />,
    jpeg: <JpegIcon />,
    jpg: <JpgIcon />,
    pdf: <PdfIcon />,
    png: <PngIcon />,
    ppt: <PptIcon />,
    pptx: <PptxIcon />,
    psd: <PsdIcon />,
    rar: <RarIcon />,
    svg: <SvgIcon />,
    tif: <TifIcon />,
    tiff: <TiffIcon />,
    xls: <XlsIcon />,
    xlsx: <XlsxIcon />,
    zip: <ZipIcon />,
  };

  return IconMap[type] || <DefaultFileTypeIcon />;
};

export const getFileExtension = (fileName: string) => {
  return (fileName?.split('.').pop() || '').toLowerCase();
};

export const isPDF = (fileName: string) => {
  const ext = getFileExtension(fileName);
  return ext === 'pdf';
};

export const isImage = (fileName: string) => {
  const ext = getFileExtension(fileName);
  return /gif|jpeg|png|jpg|svg/.test(ext);
};
